<template>
  <!-- class="aside-hoverable" -->
  <div id="kt_aside" class="aside aside-dark aside-hoverable" data-kt-drawer="true" data-kt-drawer-name="aside"
      data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true"
      data-kt-drawer-width="{default:'200px', '300px': '250px'}" data-kt-drawer-direction="start"
      data-kt-drawer-toggle="#kt_aside_mobile_toggle">

  <!--begin::Aside menu-->
  <div class="aside-menu flex-column-fluid">
  <!--begin::Aside Menu-->
    <div class="hover-scroll-overlay-y aside-menu-wrapper" id="kt_aside_menu_wrapper" 
        data-kt-scroll="true"
        data-kt-scroll-activate="{default: false, lg: true}" 
        data-kt-scroll-height="auto"
        data-kt-scroll-wrappers="{default: '#kt_header, #kt_aside_footer', lg: '#kt_header, #kt_aside_footer'}"
        data-kt-scroll-offset="75px">
      <!--begin::Menu-->
      <div class="menu menu-column text-white menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 " id="kt_aside_menu" data-kt-menu="true">
        <div v-if="!$vprops.is_tenant" class="menu-item" :class="{ 'show': hasActiveChildren('/clients') }">
          <router-link custom :to="{name: 'clients'}" v-slot="{ href, navigate, isActive, isExactActive }">
            <a class="menu-link rounded" :class="[isActive && 'active', isExactActive && 'active']" :href="href" @click="navigate">
            <span class="menu-icon me-0">
              <!--begin::Svg Icon | path: icons/duotune/art/art002.svg-->
              <span class="svg-icon svg-icon-sm">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 17.0002V11.4522C20 10.9179 19.9995 10.6506 19.9346 10.4019C19.877 10.1816 19.7825 9.97307 19.6546 9.78464C19.5102 9.57201 19.3096 9.39569 18.9074 9.04383L14.1074 4.84383C13.3608 4.19054 12.9875 3.86406 12.5674 3.73982C12.1972 3.63035 11.8026 3.63035 11.4324 3.73982C11.0126 3.86397 10.6398 4.19014 9.89436 4.84244L5.09277 9.04383C4.69064 9.39569 4.49004 9.57201 4.3457 9.78464C4.21779 9.97307 4.12255 10.1816 4.06497 10.4019C4 10.6506 4 10.9179 4 11.4522V17.0002C4 17.932 4 18.3978 4.15224 18.7654C4.35523 19.2554 4.74432 19.6452 5.23438 19.8482C5.60192 20.0005 6.06786 20.0005 6.99974 20.0005C7.93163 20.0005 8.39808 20.0005 8.76562 19.8482C9.25568 19.6452 9.64467 19.2555 9.84766 18.7654C9.9999 18.3979 10 17.932 10 17.0001V16.0001C10 14.8955 10.8954 14.0001 12 14.0001C13.1046 14.0001 14 14.8955 14 16.0001V17.0001C14 17.932 14 18.3979 14.1522 18.7654C14.3552 19.2555 14.7443 19.6452 15.2344 19.8482C15.6019 20.0005 16.0679 20.0005 16.9997 20.0005C17.9316 20.0005 18.3981 20.0005 18.7656 19.8482C19.2557 19.6452 19.6447 19.2554 19.8477 18.7654C19.9999 18.3978 20 17.932 20 17.0002Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
              <!--end::Svg Icon-->
            </span>
            <span class="menu-title">Clients</span>
            </a>
          </router-link>
        </div>


        <div v-if="$vprops.is_tenant" data-kt-menu-trigger="click" class="menu-item menu-accordion" :class="{ 'show' : hasActiveChildren('/dashboard') }">
          <span class="menu-link rounded">
            <span class="menu-icon me-0">
              <span class="svg-icon svg-icon-sm">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 17.0002V11.4522C20 10.9179 19.9995 10.6506 19.9346 10.4019C19.877 10.1816 19.7825 9.97307 19.6546 9.78464C19.5102 9.57201 19.3096 9.39569 18.9074 9.04383L14.1074 4.84383C13.3608 4.19054 12.9875 3.86406 12.5674 3.73982C12.1972 3.63035 11.8026 3.63035 11.4324 3.73982C11.0126 3.86397 10.6398 4.19014 9.89436 4.84244L5.09277 9.04383C4.69064 9.39569 4.49004 9.57201 4.3457 9.78464C4.21779 9.97307 4.12255 10.1816 4.06497 10.4019C4 10.6506 4 10.9179 4 11.4522V17.0002C4 17.932 4 18.3978 4.15224 18.7654C4.35523 19.2554 4.74432 19.6452 5.23438 19.8482C5.60192 20.0005 6.06786 20.0005 6.99974 20.0005C7.93163 20.0005 8.39808 20.0005 8.76562 19.8482C9.25568 19.6452 9.64467 19.2555 9.84766 18.7654C9.9999 18.3979 10 17.932 10 17.0001V16.0001C10 14.8955 10.8954 14.0001 12 14.0001C13.1046 14.0001 14 14.8955 14 16.0001V17.0001C14 17.932 14 18.3979 14.1522 18.7654C14.3552 19.2555 14.7443 19.6452 15.2344 19.8482C15.6019 20.0005 16.0679 20.0005 16.9997 20.0005C17.9316 20.0005 18.3981 20.0005 18.7656 19.8482C19.2557 19.6452 19.6447 19.2554 19.8477 18.7654C19.9999 18.3978 20 17.932 20 17.0002Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
            </span>
            <span class="menu-title">Dashboard</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion">
            <router-link custom :to="{name: 'dashboard', params:{module:'project'}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href" @click.prevent="(...m) => $isProperModule('project') ? navigate(m) : openLinkInNewTab(href)">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Projects</span>
                </a>
              </div>
            </router-link>
            <router-link custom :to="{name: 'dashboard', params:{module:'crm'}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click.prevent="(...m) => $isProperModule('crm') ? navigate(m) : openLinkInNewTab(href)">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Opportunities</span>
                </a>
              </div>
            </router-link>
          </div>
        </div>
        <div v-if="$vprops.is_tenant" data-kt-menu-trigger="click" class="menu-item menu-accordion" :class="{ 'show' : hasActiveChildren('/finder') }">
          <span class="menu-link rounded">
            <span class="menu-icon me-0">
              <span class="svg-icon svg-icon-sm">
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13 13L19 19M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
            </span>
            <span class="menu-title">Finder</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion">
            <router-link custom :to="{name: 'person_finder', params:{module:$module}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Person Finder</span>
                </a>
              </div>
            </router-link>
            <!--<router-link custom :to="{name: 'company_finder', params:{module:$module}}" v-slot="{ href, navigate, isActive, isExactActive }">-->
            <!--  <div class="menu-item">-->
            <!--    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"-->
            <!--      @click="navigate">-->
            <!--      <span class="menu-bullet">-->
            <!--        <span class="bullet bullet-dot"></span>-->
            <!--      </span>-->
            <!--      <span class="menu-title">Company Finder</span>-->
            <!--    </a>-->
            <!--  </div>-->
            <!--</router-link>-->
            <router-link custom :to="{name: 'company_information', params:{module:$module}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Company Information</span>
                </a>
              </div>
            </router-link>
          </div>
        </div>

        <div v-if="$vprops.is_tenant" class="menu-item">
            <a class="menu-link rounded" href="https://chat-oaklins.roclo.com/login" target="_blank">
            <span class="menu-icon me-0">
              <span class="svg-icon svg-icon-sm">
                <svg version="1.1" trans id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 122.88 70.09"><g><path class="st0" d="M45.63,32.77c3.56,0,6.45,2.89,6.45,6.45c0,3.56-2.89,6.45-6.45,6.45c-3.56,0-6.45-2.89-6.45-6.45 C39.18,35.65,42.07,32.77,45.63,32.77L45.63,32.77z M61.44,7.74c12.62,0,24.19,3.01,32.7,7.87c5.17,2.95,9.31,6.62,12.07,10.81 c1.23,0.11,2.41,0.29,3.52,0.52c0.11,0.02,0.22,0.05,0.32,0.07V12.02c-1.92-1.11-3.22-3.19-3.22-5.58c0-3.56,2.88-6.44,6.44-6.44 c3.56,0,6.44,2.88,6.44,6.44c0,2.38-1.29,4.46-3.22,5.58v17.43c2.55,1.51,4.66,3.64,5.72,6.57c1.82,5.01-0.12,10.84-5.57,14.02 c-2.92,1.7-6.54,2.53-10.98,2.23l0-0.06c-2.75,3.85-6.68,7.24-11.52,10.01c-8.51,4.86-20.08,7.87-32.7,7.87 c-12.62,0-24.19-3.01-32.7-7.87c-4.84-2.76-8.77-6.15-11.52-10.01l0,0.06c-4.44,0.29-8.06-0.53-10.98-2.23 c-5.46-3.18-7.39-9.01-5.57-14.02c1.06-2.93,3.17-5.06,5.72-6.57V12.02C4.46,10.9,3.17,8.82,3.17,6.44C3.17,2.88,6.05,0,9.6,0 c3.56,0,6.44,2.88,6.44,6.44c0,2.38-1.29,4.46-3.22,5.58V27c0.11-0.02,0.22-0.05,0.32-0.07c1.11-0.23,2.28-0.4,3.52-0.52 c2.76-4.19,6.9-7.86,12.07-10.81C37.25,10.75,48.82,7.74,61.44,7.74L61.44,7.74z M86.36,29.31c-6.24-3.56-15.04-5.77-24.92-5.77 c-9.88,0-18.68,2.2-24.92,5.77c-4.89,2.79-7.92,6.22-7.92,9.6c0,3.39,3.03,6.81,7.92,9.6c6.24,3.56,15.04,5.77,24.92,5.77 c9.88,0,18.68-2.2,24.92-5.77c4.89-2.79,7.92-6.22,7.92-9.6C94.28,35.53,91.25,32.11,86.36,29.31L86.36,29.31z M78.62,32.77 c3.56,0,6.45,2.89,6.45,6.45c0,3.56-2.89,6.45-6.45,6.45s-6.45-2.89-6.45-6.45C72.17,35.65,75.06,32.77,78.62,32.77L78.62,32.77z" fill="#D1D5DB"/></g></svg>
              </span>
            </span>
            <span class="menu-title">Oaklins Chatbot</span>
            </a>
        </div>
        <div v-if="$vprops.is_tenant" class="menu-item">
         
            <a class="menu-link rounded" href="https://chat.roclo.com/" target="_blank">
            <span class="menu-icon me-0">
              <span class="svg-icon svg-icon-sm">
                <svg version="1.1" trans id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 122.88 70.09"><g><path class="st0" d="M45.63,32.77c3.56,0,6.45,2.89,6.45,6.45c0,3.56-2.89,6.45-6.45,6.45c-3.56,0-6.45-2.89-6.45-6.45 C39.18,35.65,42.07,32.77,45.63,32.77L45.63,32.77z M61.44,7.74c12.62,0,24.19,3.01,32.7,7.87c5.17,2.95,9.31,6.62,12.07,10.81 c1.23,0.11,2.41,0.29,3.52,0.52c0.11,0.02,0.22,0.05,0.32,0.07V12.02c-1.92-1.11-3.22-3.19-3.22-5.58c0-3.56,2.88-6.44,6.44-6.44 c3.56,0,6.44,2.88,6.44,6.44c0,2.38-1.29,4.46-3.22,5.58v17.43c2.55,1.51,4.66,3.64,5.72,6.57c1.82,5.01-0.12,10.84-5.57,14.02 c-2.92,1.7-6.54,2.53-10.98,2.23l0-0.06c-2.75,3.85-6.68,7.24-11.52,10.01c-8.51,4.86-20.08,7.87-32.7,7.87 c-12.62,0-24.19-3.01-32.7-7.87c-4.84-2.76-8.77-6.15-11.52-10.01l0,0.06c-4.44,0.29-8.06-0.53-10.98-2.23 c-5.46-3.18-7.39-9.01-5.57-14.02c1.06-2.93,3.17-5.06,5.72-6.57V12.02C4.46,10.9,3.17,8.82,3.17,6.44C3.17,2.88,6.05,0,9.6,0 c3.56,0,6.44,2.88,6.44,6.44c0,2.38-1.29,4.46-3.22,5.58V27c0.11-0.02,0.22-0.05,0.32-0.07c1.11-0.23,2.28-0.4,3.52-0.52 c2.76-4.19,6.9-7.86,12.07-10.81C37.25,10.75,48.82,7.74,61.44,7.74L61.44,7.74z M86.36,29.31c-6.24-3.56-15.04-5.77-24.92-5.77 c-9.88,0-18.68,2.2-24.92,5.77c-4.89,2.79-7.92,6.22-7.92,9.6c0,3.39,3.03,6.81,7.92,9.6c6.24,3.56,15.04,5.77,24.92,5.77 c9.88,0,18.68-2.2,24.92-5.77c4.89-2.79,7.92-6.22,7.92-9.6C94.28,35.53,91.25,32.11,86.36,29.31L86.36,29.31z M78.62,32.77 c3.56,0,6.45,2.89,6.45,6.45c0,3.56-2.89,6.45-6.45,6.45s-6.45-2.89-6.45-6.45C72.17,35.65,75.06,32.77,78.62,32.77L78.62,32.77z" fill="#D1D5DB"/></g></svg>
              </span>
            </span>
            <span class="menu-title">Cavendish Chatbot</span>
            </a>
        </div>

        <div class="menu-content">
          <div class="separator mx-1 my-4"></div>
        </div>
        
        <div v-if="$hasPermission('Tabs', 'companies')" class="menu-item"
                  :class="{ 'show' : hasActiveChildren('/companies') }">
          <router-link custom :to="{name: 'companies', params: {module: $module}}" v-slot="{ href, navigate, isActive, isExactActive }">
            <a class="menu-link rounded py-3" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                @click="navigate">
                <span class="menu-icon me-0">
                  <span class="svg-icon svg-icon-sm">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 20H4M4 20H14M4 20V6.2002C4 5.08009 4 4.51962 4.21799 4.0918C4.40973 3.71547 4.71547 3.40973 5.0918 3.21799C5.51962 3 6.08009 3 7.2002 3H10.8002C11.9203 3 12.4796 3 12.9074 3.21799C13.2837 3.40973 13.5905 3.71547 13.7822 4.0918C14 4.5192 14 5.07899 14 6.19691V12M14 20H20M14 20V12M20 20H22M20 20V12C20 11.0681 19.9999 10.6024 19.8477 10.2349C19.6447 9.74481 19.2557 9.35523 18.7656 9.15224C18.3981 9 17.9316 9 16.9997 9C16.0679 9 15.6019 9 15.2344 9.15224C14.7443 9.35523 14.3552 9.74481 14.1522 10.2349C14 10.6024 14 11.0681 14 12M7 10H11M7 7H11" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  </span>
                </span>
              <span class="menu-title">Companies</span>
            </a>
          </router-link>
        </div>

        <div v-if="$hasPermission('Tabs', 'people')" data-kt-menu-trigger="click" class="menu-item menu-accordion"
            :class="{ 'show' : hasActiveChildren('/people') }">
          <span class="menu-link rounded">
            <span class="menu-icon me-0">
              <span class="svg-icon svg-icon-sm">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 21C20 18.2386 16.4183 16 12 16C7.58172 16 4 18.2386 4 21M12 13C9.23858 13 7 10.7614 7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8C17 10.7614 14.7614 13 12 13Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
            </span>
            <span class="menu-title">Contacts</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion">
            <router-link v-if="$isProperModule('project')" custom :to="{name: 'project_people'}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href" @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Contacts</span>
                </a>
              </div>
            </router-link>
            <router-link v-if="$isProperModule('crm')" custom :to="{name: 'crm_people'}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href" @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Contacts</span>
                </a>
              </div>
            </router-link>
            <router-link custom :to="{name: 'people_tracker', params: {module: $module}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href" @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Job Changes</span>
                </a>
              </div>
            </router-link>
          </div>
        </div>

        <div v-if="$vprops.is_tenant && $hasPermission('Tabs', 'projects')" data-kt-menu-trigger="click" class="menu-item menu-accordion"
            :class="{ 'show' : hasActiveChildren('/projects') }">
          <span class="menu-link rounded">
            <span class="menu-icon me-0">
              <span class="svg-icon svg-icon-sm">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 17H15M9 14H15M13.0004 3.00087C12.9048 3 12.7974 3 12.6747 3H8.2002C7.08009 3 6.51962 3 6.0918 3.21799C5.71547 3.40973 5.40973 3.71547 5.21799 4.0918C5 4.51962 5 5.08009 5 6.2002V17.8002C5 18.9203 5 19.4801 5.21799 19.9079C5.40973 20.2842 5.71547 20.5905 6.0918 20.7822C6.51921 21 7.079 21 8.19694 21L15.8031 21C16.921 21 17.48 21 17.9074 20.7822C18.2837 20.5905 18.5905 20.2842 18.7822 19.9079C19 19.4805 19 18.9215 19 17.8036V9.32568C19 9.20302 18.9999 9.09553 18.999 9M13.0004 3.00087C13.2858 3.00348 13.4657 3.01407 13.6382 3.05547C13.8423 3.10446 14.0379 3.18526 14.2168 3.29492C14.4186 3.41857 14.5918 3.59181 14.9375 3.9375L18.063 7.06298C18.4089 7.40889 18.5809 7.58136 18.7046 7.78319C18.8142 7.96214 18.8953 8.15726 18.9443 8.36133C18.9857 8.53379 18.9964 8.71454 18.999 9M13.0004 3.00087L13 5.80021C13 6.92031 13 7.48015 13.218 7.90797C13.4097 8.2843 13.7155 8.59048 14.0918 8.78223C14.5192 9 15.079 9 16.1969 9H18.999" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
            </span>
            <span class="menu-title">Projects</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion">
            <!--<router-link custom :to="{name: 'my_projects'}" v-slot="{ href, navigate, isActive, isExactActive }">-->
            <!--  <div class="menu-item">-->
            <!--    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"-->
            <!--      @click.prevent="(...m) => $isProperModule('crm') ? openLinkInNewTab(href) : navigate(m)">-->
            <!--      <span class="menu-bullet">-->
            <!--        <span class="bullet bullet-dot"></span>-->
            <!--      </span>-->
            <!--      <span class="menu-title">My Projects</span>-->
            <!--    </a>-->
            <!--  </div>-->
            <!--</router-link>-->
            <router-link custom :to="{name: 'all_projects', params: {mode: 'list'}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click.prevent="(...m) => $isProperModule('crm') ? openLinkInNewTab(href) : navigate(m)">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">All Projects</span>
                </a>
              </div>
            </router-link>
            <router-link custom :to="{name: 'buyer_report_'}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click.prevent="(...m) => $isProperModule('crm') ? openLinkInNewTab(href) : navigate(m)">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Project Reports</span>
                </a>
              </div>
            </router-link>
            <router-link custom :to="{name: 'distribution_'}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click.prevent="(...m) => $isProperModule('crm') ? openLinkInNewTab(href) : navigate(m)">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Document Distribution</span>
                </a>
              </div>
            </router-link>
            <router-link custom :to="{name: 'projects_summary'}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click.prevent="(...m) => $isProperModule('crm') ? openLinkInNewTab(href) : navigate(m)">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Projects Summary</span>
                </a>
              </div>
            </router-link>
            <!-- <router-link custom :to="{name: 'resource_tabs', params:{module:$module, resource: 'project'}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Resource Tabs</span>
                </a>
              </div>
            </router-link> -->
          </div>
        </div>

        <div v-if="0" data-kt-menu-trigger="click" class="menu-item menu-accordion"
        :class="{ 'show' : hasActiveChildren('/private-equity') }">
          <span class="menu-link rounded">
            <span class="menu-icon me-0">
              <span class="svg-icon svg-icon-sm">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M10.5 10.5L16 8L13.5 13.5L8 16L10.5 10.5Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
            </span>
            <span class="menu-title">Private Equity</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion">
            <router-link custom :to="{name: 'private_equity'}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isExactActive && 'active']" :href="href"
                   @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">PE Search</span>
                </a>
              </div>
            </router-link>
            <router-link custom :to="{name: 'private_equity_activity'}"
                         v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isExactActive && 'active']" :href="href"
                   @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">PE Activity</span>
                </a>
              </div>
            </router-link>
            <!--  -->
            <div v-if="$isProperModule('project')" data-kt-menu-trigger="click" class="menu-item menu-accordion"
             :class="{ 'show' : hasActiveChildren('/private-equity') }">
                <span class="menu-link">
                  <span class="menu-icon me-0">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Opportunities Shown</span>
                  <span class="menu-arrow"></span>
                </span>
                <div class="menu-sub menu-sub-accordion">
                  <router-link custom :to="{name: 'private_equity_deals'}"
                         v-slot="{ href, navigate, isActive, isExactActive }">
                      <div class="menu-item">
                        <a class="menu-link" :class="[isExactActive && 'active']" :href="href"
                           @click="navigate">
                          <span class="menu-bullet">
                            <span class="bullet bullet-dot"></span>
                          </span>
                          <span class="menu-title">By PE House</span>
                        </a>
                      </div>
                    </router-link>
                    <router-link custom :to="{name: 'project_private_equity_deals'}"
                                 v-slot="{ href, navigate, isActive, isExactActive }">
                      <div class="menu-item">
                        <a class="menu-link" :class="[isExactActive && 'active']" :href="href"
                           @click="navigate">
                          <span class="menu-bullet">
                            <span class="bullet bullet-dot"></span>
                          </span>
                          <span class="menu-title">By Project</span>
                        </a>
                      </div>
                    </router-link>
                </div>
              </div>

            <!--  -->
            
          </div>

        </div>

        <div v-if="$vprops.is_tenant && $hasPermission('Tabs', 'pitchbook')" class="menu-item">
          <router-link custom :to="{name: 'pitchbooks'}"
                            v-slot="{ href, navigate, isActive, isExactActive }">
              <a class="menu-link rounded" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                @click.prevent="(...m) => $isProperModule('crm') ? openLinkInNewTab(href) : navigate(m)">
                <span class="menu-icon me-0">
                  <span class="svg-icon svg-icon-sm">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.5 21H20.4706C20.763 21 21.0002 20.7631 21.0002 20.4707L21 14.5293M7.98047 20.6713L20.6421 14.7671C20.9071 14.6435 21.0217 14.3285 20.8981 14.0635L18.3872 8.6792C18.2636 8.41421 17.9486 8.29914 17.6836 8.42271L12.0303 11.0591M9.88182 18.4048C9.38152 20.2719 7.46235 21.38 5.59521 20.8797C3.72808 20.3794 2.61982 18.4604 3.12011 16.5933L6.73596 3.09863C6.81163 2.81621 7.10168 2.64855 7.3841 2.72422L13.1231 4.26171C13.4055 4.33738 13.5731 4.6276 13.4974 4.91002L9.88182 18.4048ZM6.5 17.6001H6.502L6.50195 17.6021L6.5 17.6021V17.6001Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </span>
                </span>
                <span class="menu-title">Pitchbooks</span>
              </a>
          </router-link>
        </div>

        <div v-if="$hasPermission('Tabs', 'opportunities')" class="menu-item">
          <router-link custom :to="{name: 'crm_opportunities', params: {mode: 'list'}}"
                            v-slot="{ href, navigate, isActive, isExactActive }">
              <a class="menu-link rounded" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                @click.prevent="(...m) => $isProperModule('crm') ? navigate(m) : openLinkInNewTab(href)">
                <span class="menu-icon me-0">
                  <span class="svg-icon svg-icon-sm">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3 9V19.4C3 19.9601 3 20.2399 3.10899 20.4538C3.20487 20.642 3.35774 20.7952 3.5459 20.8911C3.7596 21 4.0395 21 4.59846 21H15.0001M17 8L13 12L11 10M7 13.8002V6.2002C7 5.08009 7 4.51962 7.21799 4.0918C7.40973 3.71547 7.71547 3.40973 8.0918 3.21799C8.51962 3 9.08009 3 10.2002 3H17.8002C18.9203 3 19.4801 3 19.9079 3.21799C20.2842 3.40973 20.5905 3.71547 20.7822 4.0918C21.0002 4.51962 21.0002 5.07969 21.0002 6.19978L21.0002 13.7998C21.0002 14.9199 21.0002 15.48 20.7822 15.9078C20.5905 16.2841 20.2842 16.5905 19.9079 16.7822C19.4805 17 18.9215 17 17.8036 17H10.1969C9.07899 17 8.5192 17 8.0918 16.7822C7.71547 16.5905 7.40973 16.2842 7.21799 15.9079C7 15.4801 7 14.9203 7 13.8002Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </span>
                </span>
                <span class="menu-title">Opportunities</span>
              </a>
          </router-link>
        </div>

        <div v-if="0 && $hasPermission('Tabs', 'opportunities')" data-kt-menu-trigger="click" class="menu-item menu-accordion"
          :class="{ 'show' : hasActiveChildren('/opportunities') }">
          <span class="menu-link rounded">
            <span class="menu-icon me-0">
              <span class="svg-icon svg-icon-sm">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 9V19.4C3 19.9601 3 20.2399 3.10899 20.4538C3.20487 20.642 3.35774 20.7952 3.5459 20.8911C3.7596 21 4.0395 21 4.59846 21H15.0001M17 8L13 12L11 10M7 13.8002V6.2002C7 5.08009 7 4.51962 7.21799 4.0918C7.40973 3.71547 7.71547 3.40973 8.0918 3.21799C8.51962 3 9.08009 3 10.2002 3H17.8002C18.9203 3 19.4801 3 19.9079 3.21799C20.2842 3.40973 20.5905 3.71547 20.7822 4.0918C21.0002 4.51962 21.0002 5.07969 21.0002 6.19978L21.0002 13.7998C21.0002 14.9199 21.0002 15.48 20.7822 15.9078C20.5905 16.2841 20.2842 16.5905 19.9079 16.7822C19.4805 17 18.9215 17 17.8036 17H10.1969C9.07899 17 8.5192 17 8.0918 16.7822C7.71547 16.5905 7.40973 16.2842 7.21799 15.9079C7 15.4801 7 14.9203 7 13.8002Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
            </span>
            <span class="menu-title">Opportunities</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion">
            <router-link custom :to="{name: 'crm_opportunities', params: {mode: 'list'}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click.prevent="(...m) => $isProperModule('crm') ? navigate(m) : openLinkInNewTab(href)">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Opportunities</span>
                </a>
              </div>
            </router-link>
            <div data-kt-menu-trigger="click" class="menu-item menu-accordion"
              :class="{ 'show' : hasActiveChildren('/opportunities/tracker') }">
              <span class="menu-link">
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">Tracker</span>
                <span class="menu-arrow"></span>
              </span>
              <div class="menu-sub menu-sub-accordion">
                <router-link custom :to="{name: 'opportunity_tracker', params: {wide: 'company'}}" v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                      @click.prevent="(...m) => $isProperModule('project') ? openLinkInNewTab(href) : navigate(m)">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Company Trackers</span>
                    </a>
                  </div>
                </router-link>
                <router-link custom :to="{name: 'opportunity_tracker', params: {wide: 'team'}}" v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                      @click.prevent="(...m) => $isProperModule('project') ? openLinkInNewTab(href) : navigate(m)">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Team Trackers</span>
                    </a>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="menu-item"
          :class="{ 'show' : hasActiveChildren('/staffing') }">
          <router-link custom :to="{name: 'staffing', params: {module: $module}}"
                            v-slot="{ href, navigate, isActive, isExactActive }">
              <a class="menu-link rounded" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                  @click="navigate">
                <span class="menu-icon me-0">
                  <span class="svg-icon svg-icon-sm">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 19.9999C21 18.2583 19.3304 16.7767 17 16.2275M15 20C15 17.7909 12.3137 16 9 16C5.68629 16 3 17.7909 3 20M15 13C17.2091 13 19 11.2091 19 9C19 6.79086 17.2091 5 15 5M9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9C13 11.2091 11.2091 13 9 13Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </span>
                </span>
                <span class="menu-title">Staffing</span>
              </a>
          </router-link>
        </div>

        <!--<div data-kt-menu-trigger="click" class="menu-item menu-accordion mb-1" :class="{ 'show' : hasActiveChildren('/stock-companies') }">-->
        <!--  <router-link custom :to="{name: 'stock_companies', params: {module: $module}}" v-slot="{ href, navigate, isActive, isExactActive }">-->
        <!--    <a class="menu-link rounded" :class="[isActive && 'active', isExactActive && 'active']" :href="href"-->
        <!--      @click="navigate">-->
        <!--    <span class="menu-icon me-0">-->
        <!--      &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen002.svg&ndash;&gt;-->
        <!--      <span class="svg-icon svg-icon-sm">-->
        <!--        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--          <path opacity="0.3"-->
        <!--                d="M4.05424 15.1982C8.34524 7.76818 13.5782 3.26318 20.9282 2.01418C21.0729 1.98837 21.2216 1.99789 21.3618 2.04193C21.502 2.08597 21.6294 2.16323 21.7333 2.26712C21.8372 2.37101 21.9144 2.49846 21.9585 2.63863C22.0025 2.7788 22.012 2.92754 21.9862 3.07218C20.7372 10.4222 16.2322 15.6552 8.80224 19.9462L4.05424 15.1982ZM3.81924 17.3372L2.63324 20.4482C2.58427 20.5765 2.5735 20.7163 2.6022 20.8507C2.63091 20.9851 2.69788 21.1082 2.79503 21.2054C2.89218 21.3025 3.01536 21.3695 3.14972 21.3982C3.28408 21.4269 3.42387 21.4161 3.55224 21.3672L6.66524 20.1802L3.81924 17.3372ZM16.5002 5.99818C16.2036 5.99818 15.9136 6.08615 15.6669 6.25097C15.4202 6.41579 15.228 6.65006 15.1144 6.92415C15.0009 7.19824 14.9712 7.49984 15.0291 7.79081C15.0869 8.08178 15.2298 8.34906 15.4396 8.55884C15.6494 8.76862 15.9166 8.91148 16.2076 8.96935C16.4986 9.02723 16.8002 8.99753 17.0743 8.884C17.3484 8.77046 17.5826 8.5782 17.7474 8.33153C17.9123 8.08486 18.0002 7.79485 18.0002 7.49818C18.0002 7.10035 17.8422 6.71882 17.5609 6.43752C17.2796 6.15621 16.8981 5.99818 16.5002 5.99818Z"-->
        <!--                fill="currentColor"/>-->
        <!--          <path-->
        <!--              d="M4.05423 15.1982L2.24723 13.3912C2.15505 13.299 2.08547 13.1867 2.04395 13.0632C2.00243 12.9396 1.9901 12.8081 2.00793 12.679C2.02575 12.5498 2.07325 12.4266 2.14669 12.3189C2.22013 12.2112 2.31752 12.1219 2.43123 12.0582L9.15323 8.28918C7.17353 10.3717 5.4607 12.6926 4.05423 15.1982ZM8.80023 19.9442L10.6072 21.7512C10.6994 21.8434 10.8117 21.9129 10.9352 21.9545C11.0588 21.996 11.1903 22.0083 11.3195 21.9905C11.4486 21.9727 11.5718 21.9252 11.6795 21.8517C11.7872 21.7783 11.8765 21.6809 11.9402 21.5672L15.7092 14.8442C13.6269 16.8245 11.3061 18.5377 8.80023 19.9442ZM7.04023 18.1832L12.5832 12.6402C12.7381 12.4759 12.8228 12.2577 12.8195 12.032C12.8161 11.8063 12.725 11.5907 12.5653 11.4311C12.4057 11.2714 12.1901 11.1803 11.9644 11.1769C11.7387 11.1736 11.5205 11.2583 11.3562 11.4132L5.81323 16.9562L7.04023 18.1832Z"-->
        <!--              fill="currentColor"/>-->
        <!--        </svg>-->
        <!--      </span>-->
        <!--      &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--    </span>-->
        <!--      <span class="menu-title">FMP Companies</span>-->
        <!--    </a>-->
        <!--  </router-link>-->
        <!--</div>-->

        <div v-if="$vprops.is_tenant" data-kt-menu-trigger="click" class="menu-item menu-accordion" :class="{ 'show' : hasActiveChildren('/stock-companies/fmp') }">
          <span class="menu-link rounded">
            <span class="menu-icon me-0">
              <span class="svg-icon svg-icon-sm">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                     x="0px" y="0px"
                     viewBox="0 0 119.4 122.88">
                  <g>
                    <path fill="#D1D5DB" d="M19.39,64.84v39.84a1.84,1.84,0,0,1-1.83,1.82H1.83A1.83,1.83,0,0,1,0,104.68V64.84ZM0,51.83,41.59,15.44
                      c9.21,9,18.14,19.93,27.25,28.93L102.07,11,91.37.28,122.88,0V31.78L112.61,21.51c-7.37,7.47-24.8,23.92-32.17,31.3
                      -9.33,9.32-13.78,9.49-23.1.17L41.59,35.46,23.13,51.83ZM114.37,38.69v66a1.84,1.84,0,0,1-1.82,1.82H96.81A1.84,1.84,0,0,1,95,
                      104.68V57.29c3-2.91,6.5-6.29,10.07-9.73l7.45-7.17a24.16,24.16,0,0,1,1.87-1.7ZM82.71,68.34v36.34a1.84,1.84,0,0,1-1.83,
                      1.82H65.15a1.84,1.84,0,0,1-1.83-1.82V72.22a22.48,22.48,0,0,0,5.73.63,24,24,0,0,0,13.66-4.51Zm-31.66-3v39.29a1.84,
                      1.84,0,0,1-1.83,1.82H33.48a1.83,1.83,0,0,1-1.82-1.82V62q.48-.36.93-.75l7.86-7,6.34,7,.49.51q1.92,1.93,3.77,3.52Z"/>
                  </g>
                </svg>

              </span>
            </span>
            <span class="menu-title">Comparables</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion">
            <router-link custom :to="{name: 'stock_companies', params:{module:$module, mode:'fmp'}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Comparable Companies</span>
                </a>
              </div>
            </router-link>
          </div>
        </div>

        <!--<div data-kt-menu-trigger="click" class="menu-item menu-accordion mb-1" :class="{ 'show' : hasActiveChildren('/company-financials') }">-->
        <!--  <router-link custom :to="{name: 'company_financials', params: {module: $module}}" v-slot="{ href, navigate, isActive, isExactActive }">-->
        <!--    <a class="menu-link rounded" :class="[isActive && 'active', isExactActive && 'active']" :href="href"-->
        <!--      @click="navigate">-->
        <!--    <span class="menu-icon me-0">-->
        <!--      &lt;!&ndash;begin::Svg Icon | path: icons/duotune/general/gen002.svg&ndash;&gt;-->
        <!--      <span class="svg-icon svg-icon-sm">-->
        <!--        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
        <!--          <path opacity="0.3"-->
        <!--                d="M4.05424 15.1982C8.34524 7.76818 13.5782 3.26318 20.9282 2.01418C21.0729 1.98837 21.2216 1.99789 21.3618 2.04193C21.502 2.08597 21.6294 2.16323 21.7333 2.26712C21.8372 2.37101 21.9144 2.49846 21.9585 2.63863C22.0025 2.7788 22.012 2.92754 21.9862 3.07218C20.7372 10.4222 16.2322 15.6552 8.80224 19.9462L4.05424 15.1982ZM3.81924 17.3372L2.63324 20.4482C2.58427 20.5765 2.5735 20.7163 2.6022 20.8507C2.63091 20.9851 2.69788 21.1082 2.79503 21.2054C2.89218 21.3025 3.01536 21.3695 3.14972 21.3982C3.28408 21.4269 3.42387 21.4161 3.55224 21.3672L6.66524 20.1802L3.81924 17.3372ZM16.5002 5.99818C16.2036 5.99818 15.9136 6.08615 15.6669 6.25097C15.4202 6.41579 15.228 6.65006 15.1144 6.92415C15.0009 7.19824 14.9712 7.49984 15.0291 7.79081C15.0869 8.08178 15.2298 8.34906 15.4396 8.55884C15.6494 8.76862 15.9166 8.91148 16.2076 8.96935C16.4986 9.02723 16.8002 8.99753 17.0743 8.884C17.3484 8.77046 17.5826 8.5782 17.7474 8.33153C17.9123 8.08486 18.0002 7.79485 18.0002 7.49818C18.0002 7.10035 17.8422 6.71882 17.5609 6.43752C17.2796 6.15621 16.8981 5.99818 16.5002 5.99818Z"-->
        <!--                fill="currentColor"/>-->
        <!--          <path-->
        <!--              d="M4.05423 15.1982L2.24723 13.3912C2.15505 13.299 2.08547 13.1867 2.04395 13.0632C2.00243 12.9396 1.9901 12.8081 2.00793 12.679C2.02575 12.5498 2.07325 12.4266 2.14669 12.3189C2.22013 12.2112 2.31752 12.1219 2.43123 12.0582L9.15323 8.28918C7.17353 10.3717 5.4607 12.6926 4.05423 15.1982ZM8.80023 19.9442L10.6072 21.7512C10.6994 21.8434 10.8117 21.9129 10.9352 21.9545C11.0588 21.996 11.1903 22.0083 11.3195 21.9905C11.4486 21.9727 11.5718 21.9252 11.6795 21.8517C11.7872 21.7783 11.8765 21.6809 11.9402 21.5672L15.7092 14.8442C13.6269 16.8245 11.3061 18.5377 8.80023 19.9442ZM7.04023 18.1832L12.5832 12.6402C12.7381 12.4759 12.8228 12.2577 12.8195 12.032C12.8161 11.8063 12.725 11.5907 12.5653 11.4311C12.4057 11.2714 12.1901 11.1803 11.9644 11.1769C11.7387 11.1736 11.5205 11.2583 11.3562 11.4132L5.81323 16.9562L7.04023 18.1832Z"-->
        <!--              fill="currentColor"/>-->
        <!--        </svg>-->
        <!--      </span>-->
        <!--      &lt;!&ndash;end::Svg Icon&ndash;&gt;-->
        <!--    </span>-->
        <!--      <span class="menu-title">Company Financials</span>-->
        <!--    </a>-->
        <!--  </router-link>-->
        <!--</div>-->

        <div v-if="$vprops.is_tenant" data-kt-menu-trigger="click" class="menu-item menu-accordion"
             :class="{ 'show' : hasActiveChildren('/dac') }">
          <span class="menu-link rounded">
            <span class="menu-icon me-0">
              <!--begin::Svg Icon | path: icons/duotune/general/gen002.svg-->
              <span class="svg-icon svg-icon-sm">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 19.9999C21 18.2583 19.3304 16.7767 17 16.2275M15 20C15 17.7909 12.3137 16 9 16C5.68629 16 3 17.7909 3 20M15 13C17.2091 13 19 11.2091 19 9C19 6.79086 17.2091 5 15 5M9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9C13 11.2091 11.2091 13 9 13Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
              </span>
              <!--end::Svg Icon-->
            </span>
            <span class="menu-title">Deal Approval Committee</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion">
            <router-link v-if="$hasPermission('DAC Approval Committee','dac_setup')" custom :to="{name: 'dac_setup', params:{module:$module}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                   @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">DAC Setup</span>
                </a>
              </div>
            </router-link>
            <router-link v-if="$hasPermission('DAC Approval Committee','dac_submission')" custom :to="{name: 'dac_submission', params:{module:$module}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                   @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">DAC Submission</span>
                </a>
              </div>
            </router-link>
            <router-link custom :to="{name: 'dac_submission_centre', params:{module:$module}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href" @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">DAC Approval Centre</span>
                </a>
              </div>
            </router-link>
          </div>
        </div>

        <div v-if="$isProperModule('project')" data-kt-menu-trigger="click" class="menu-item menu-accordion mb-1" :class="{ 'show' : hasActiveChildren('/bespoke_table_list') }">
          <router-link custom :to="{name: 'bespoke_table_list'}" v-slot="{ href, navigate, isActive, isExactActive }">
            <a class="menu-link rounded" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
               @click="navigate">
            <span class="menu-icon me-0">
              <!--begin::Svg Icon | path: icons/duotune/general/gen002.svg-->
              <span class="svg-icon svg-icon-sm">
                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 118.96"><title>frame-grid</title><path fill="#D1D5DB" d="M3.27,0H119.61a3.26,3.26,0,0,1,3.27,3.27V115.69a3.26,3.26,0,0,1-3.27,3.27H3.27A3.26,3.26,0,0,1,0,115.69V3.27A3.26,3.26,0,0,1,3.27,0ZM116.34,81.49H84.1v30.93h32.24V81.49Zm0-37.48H84.1V75h32.24V44ZM84.1,6.54V37.47h32.24V6.54ZM77.56,81.49H45.32v30.93H77.56V81.49Zm0-37.48H45.32V75H77.56V44ZM45.32,6.54V37.47H77.56V6.54ZM38.78,81.49H6.54v30.93H38.78V81.49Zm0-37.48H6.54V75H38.78V44Zm0-37.47H6.54V37.47H38.78V6.54Z"/></svg>
              </span>
              <!--end::Svg Icon-->
            </span>
              <span class="menu-title">Tables</span>
            </a>
          </router-link>
        </div>

        <!-- <div v-if="$vprops.is_tenant" data-kt-menu-trigger="click" class="menu-item menu-accordion mb-1" :class="{ 'show' : hasActiveChildren('/maps') }">
          <router-link custom :to="{name: 'compnay_maps', params:{module:$module}}" v-slot="{ href, navigate, isActive, isExactActive }">
            <a class="menu-link rounded" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
               @click="navigate">
            <span class="menu-icon me-0">
              <span class="svg-icon svg-icon-sm">
                <img :src="static('metronic/assets/media/svg/icons/Map/Map-line-icons.svg')">

              </span>
            </span>
              <span class="menu-title">Maps</span>
            </a>
          </router-link>
        </div> -->

        <div v-if="$vprops.is_tenant" data-kt-menu-trigger="click" class="menu-item menu-accordion mb-1" :class="{ 'show' : hasActiveChildren('/activities') }">
          <router-link custom :to="{name: 'activities', params: {module: $module}}" v-slot="{ href, navigate, isActive, isExactActive }">
            <a class="menu-link rounded" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
               @click="navigate">
            <span class="menu-icon me-0">
              <!--begin::Svg Icon | path: icons/duotune/general/gen002.svg-->
              <span class="svg-icon svg-icon-sm">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 20.0001H20M4 20.0001V16.0001L12 8.00012M4 20.0001L8 20.0001L16 12.0001M12 8.00012L14.8686 5.13146L14.8704 5.12976C15.2652 4.73488 15.463 4.53709 15.691 4.46301C15.8919 4.39775 16.1082 4.39775 16.3091 4.46301C16.5369 4.53704 16.7345 4.7346 17.1288 5.12892L18.8686 6.86872C19.2646 7.26474 19.4627 7.46284 19.5369 7.69117C19.6022 7.89201 19.6021 8.10835 19.5369 8.3092C19.4628 8.53736 19.265 8.73516 18.8695 9.13061L18.8686 9.13146L16 12.0001M12 8.00012L16 12.0001" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>

              </span>
              <!--end::Svg Icon-->
            </span>
              <span class="menu-title">Activities</span>
            </a>
          </router-link>
        </div>

        <div class="menu-content">
          <div class="separator mx-1 my-4"></div>
        </div>

        <div v-if="anyAuthPerm || anyUserPerm" data-kt-menu-trigger="click" class="menu-item menu-accordion">
          <span class="menu-link rounded">
            <span class="menu-icon me-0">
              <!--begin::Svg Icon | path: icons/duotune/ecommerce/ecm007.svg-->
              <span class="svg-icon svg-icon-sm">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.3499 8.92296L19.9837 8.71923C19.9269 8.6876 19.8989 8.67172 19.8714 8.65527C19.5983 8.49169 19.3682 8.26567 19.2002 7.99526C19.1833 7.96805 19.1674 7.93952 19.1348 7.88313C19.1023 7.82681 19.0858 7.79827 19.0706 7.77002C18.92 7.4887 18.8385 7.17519 18.8336 6.8561C18.8331 6.82402 18.8332 6.79124 18.8343 6.72608L18.8415 6.30082C18.8529 5.62029 18.8587 5.27897 18.763 4.97265C18.6781 4.70057 18.536 4.44996 18.3462 4.23729C18.1317 3.99688 17.8347 3.82538 17.2402 3.4828L16.7464 3.19824C16.1536 2.85661 15.8571 2.68574 15.5423 2.6206C15.2639 2.56297 14.9765 2.56564 14.6991 2.62793C14.3859 2.69822 14.0931 2.87355 13.5079 3.22399L13.5045 3.22558L13.1507 3.43744C13.0948 3.47094 13.0665 3.48783 13.0384 3.50342C12.7601 3.65814 12.4495 3.74369 12.1312 3.7539C12.0992 3.75493 12.0665 3.75493 12.0013 3.75493C11.9365 3.75493 11.9024 3.75493 11.8704 3.7539C11.5515 3.74364 11.2402 3.65763 10.9615 3.50227C10.9334 3.48661 10.9056 3.46959 10.8496 3.43594L10.4935 3.22216C9.90422 2.8684 9.60915 2.69125 9.29427 2.6206C9.0157 2.5581 8.72737 2.55637 8.44791 2.61474C8.13236 2.68065 7.83577 2.85279 7.24258 3.19707L7.23994 3.19824L6.75228 3.48127L6.74688 3.48457C6.15904 3.82575 5.86441 3.99675 5.6517 4.23617C5.46294 4.44863 5.32185 4.69885 5.2374 4.97021C5.14194 5.27695 5.14703 5.619 5.15853 6.30273L5.16568 6.72739C5.16676 6.7917 5.16864 6.82365 5.16817 6.85528C5.16343 7.17502 5.08086 7.48917 4.92974 7.77099C4.9148 7.79886 4.8987 7.82674 4.86654 7.88241C4.83436 7.93812 4.81877 7.96582 4.80209 7.99271C4.63336 8.26456 4.40214 8.4919 4.12733 8.65576C4.10015 8.67197 4.0715 8.68755 4.01521 8.71875L3.65365 8.91911C3.05208 9.25248 2.75137 9.41931 2.53256 9.65673C2.33898 9.86676 2.19275 10.1159 2.10349 10.3872C2.00259 10.6939 2.00267 11.0378 2.00424 11.7256L2.00551 12.2877C2.00706 12.9709 2.00919 13.3122 2.11032 13.6169C2.19979 13.8864 2.34495 14.134 2.53744 14.3428C2.75502 14.5787 3.05274 14.7445 3.64974 15.0767L4.00808 15.276C4.06907 15.3099 4.09976 15.3267 4.12917 15.3444C4.40148 15.5084 4.63089 15.7351 4.79818 16.0054C4.81625 16.0346 4.8336 16.0649 4.8683 16.1255C4.90256 16.1853 4.92009 16.2153 4.93594 16.2453C5.08261 16.523 5.16114 16.8315 5.16649 17.1455C5.16707 17.1794 5.16658 17.2137 5.16541 17.2827L5.15853 17.6902C5.14695 18.3763 5.1419 18.7197 5.23792 19.0273C5.32287 19.2994 5.46484 19.55 5.65463 19.7627C5.86915 20.0031 6.16655 20.1745 6.76107 20.5171L7.25478 20.8016C7.84763 21.1432 8.14395 21.3139 8.45869 21.379C8.73714 21.4367 9.02464 21.4344 9.30209 21.3721C9.61567 21.3017 9.90948 21.1258 10.4964 20.7744L10.8502 20.5625C10.9062 20.529 10.9346 20.5122 10.9626 20.4966C11.2409 20.3419 11.5512 20.2559 11.8695 20.2457C11.9015 20.2446 11.9342 20.2446 11.9994 20.2446C12.0648 20.2446 12.0974 20.2446 12.1295 20.2457C12.4484 20.2559 12.7607 20.3422 13.0394 20.4976C13.0639 20.5112 13.0885 20.526 13.1316 20.5519L13.5078 20.7777C14.0971 21.1315 14.3916 21.3082 14.7065 21.3788C14.985 21.4413 15.2736 21.4439 15.5531 21.3855C15.8685 21.3196 16.1657 21.1471 16.7586 20.803L17.2536 20.5157C17.8418 20.1744 18.1367 20.0032 18.3495 19.7637C18.5383 19.5512 18.6796 19.3011 18.764 19.0297C18.8588 18.7252 18.8531 18.3858 18.8417 17.7119L18.8343 17.2725C18.8332 17.2081 18.8331 17.1762 18.8336 17.1445C18.8383 16.8248 18.9195 16.5104 19.0706 16.2286C19.0856 16.2008 19.1018 16.1727 19.1338 16.1172C19.166 16.0615 19.1827 16.0337 19.1994 16.0068C19.3681 15.735 19.5995 15.5074 19.8744 15.3436C19.9012 15.3276 19.9289 15.3123 19.9838 15.2818L19.9857 15.2809L20.3472 15.0806C20.9488 14.7472 21.2501 14.5802 21.4689 14.3428C21.6625 14.1327 21.8085 13.884 21.8978 13.6126C21.9981 13.3077 21.9973 12.9658 21.9958 12.2861L21.9945 11.7119C21.9929 11.0287 21.9921 10.6874 21.891 10.3828C21.8015 10.1133 21.6555 9.86564 21.463 9.65688C21.2457 9.42114 20.9475 9.25529 20.3517 8.92381L20.3499 8.92296Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M8.00033 12C8.00033 14.2091 9.79119 16 12.0003 16C14.2095 16 16.0003 14.2091 16.0003 12C16.0003 9.79086 14.2095 8 12.0003 8C9.79119 8 8.00033 9.79086 8.00033 12Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              </span>
              <!--end::Svg Icon-->
            </span>
            <span class="menu-title">Settings</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion menu-active-bg">
            <!--<div data-kt-menu-trigger="click" class="menu-item menu-accordion" :class="{ 'show': hasActiveChildren('/team/') }">
              <span class="menu-link">
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">Team</span>
                <span class="menu-arrow"></span>
              </span>
              <div class="menu-sub menu-sub-accordion menu-active-bg">
                <router-link custom :to="{name: 'invites'}"
                         v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" ::class="[isActive && 'active', isExactActive && 'active']" @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Invites</span>
                    </a>
                  </div>
                </router-link>
                <router-link custom :to="{name: 'users'}" v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" ::class="[isActive && 'active', isExactActive && 'active']" @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Users</span>
                    </a>
                  </div>
                </router-link>
              </div>
            </div>-->
            <div v-if="anyAuthPerm" data-kt-menu-trigger="click" class="menu-item menu-accordion"
                 :class="{ 'show': hasActiveChildren('/authorization/') }">
              <span class="menu-link">
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">Authorization</span>
                <span class="menu-arrow"></span>
              </span>
              <div class="menu-sub menu-sub-accordion menu-active-bg">
                <template v-for="preset in routes.authorization">
                  <router-link v-if="preset.hasAccess && preset.hasAccess()" custom
                               :to="{name: preset.route, params: {module: $module}}"
                               v-slot="{ href, navigate, isActive, isExactActive }">
                    <div class="menu-item">
                      <a class="menu-link py-3" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                         @click="navigate">
                        <span class="menu-bullet">
                          <span class="bullet bullet-dot"></span>
                        </span>
                        <span class="menu-title">{{ preset.name }}</span>
                      </a>
                    </div>
                  </router-link>
                </template>
              </div>
            </div>
            <div v-if="$hasPermission('Settings', 'invite-users') || $hasPermission('Settings', 'view-users')"
                 data-kt-menu-trigger="click" class="menu-item menu-accordion"
                 :class="{ 'show': hasActiveChildren('/team/') }">
              <span class="menu-link">
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">Users</span>
                <span class="menu-arrow"></span>
              </span>
              <div class="menu-sub menu-sub-accordion menu-active-bg">
                <router-link v-if="$hasPermission('Settings', 'invite-users')" custom
                             :to="{name: 'invites', params: {module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link py-3" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Invite Users</span>
                    </a>
                  </div>
                </router-link>
                <router-link v-if="$hasPermission('Settings', 'view-users')" custom
                             :to="{name: 'users', params: {module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link py-3" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">View Users</span>
                    </a>
                  </div>
                </router-link>
                <div v-if="$hasPermission('Settings', 'employee-settings') || $hasPermission('Settings', 'view-users')"
                     data-kt-menu-trigger="click" class="menu-item menu-accordion">
                  <span class="menu-link">
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Employee Settings</span>
                    <span class="menu-arrow"></span>
                  </span>
                  <div class="menu-sub menu-sub-accordion menu-active-bg">
                      <router-link custom :to="{name: 'job_title', params: {type: 'job_title', module: $module}}"
                                   v-slot="{ href, navigate, isActive, isExactActive }">
                        <div class="menu-item">
                          <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                             @click="navigate">
                            <span class="menu-bullet">
                              <span class="bullet bullet-dot"></span>
                            </span>
                            <span class="menu-title">Employee Title</span>
                          </a>
                        </div>
                      </router-link>
                      <router-link custom :to="{name: 'employee_sector', params: {type: 'employee_sector', module: $module}}"
                                   v-slot="{ href, navigate, isActive, isExactActive }">
                        <div class="menu-item">
                          <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                             @click="navigate">
                            <span class="menu-bullet">
                              <span class="bullet bullet-dot"></span>
                            </span>
                            <span class="menu-title">Employee Sectors</span>
                          </a>
                        </div>
                      </router-link>
                    </div>
                  </div>
              </div>
            </div>
              <router-link custom :to="{name: 'report_pages'}"  v-if="$isProperModule('project')"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                <div class="menu-item">
                  <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                     @click="navigate">
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Dashboards</span>
                  </a>
                </div>
              </router-link>

              <router-link custom :to="{name: 'crm_report_pages'}"  v-if="$isProperModule('crm')"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Dashboards</span>
                    </a>
                  </div>
              </router-link>
            

            <div v-if="$isProperModule('project')"
                 data-kt-menu-trigger="click" class="menu-item menu-accordion"
                 :class="{ 'show': hasActiveChildren('/reports/') }">
              <span class="menu-link">
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">Reports</span>
                <span class="menu-arrow"></span>
              </span>
              <div  v-if="$hasPermission('Settings', 'create_report')" class="menu-sub menu-sub-accordion menu-active-bg">
                <router-link custom :to="{name: 'report_list'}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Report List</span>
                    </a>
                  </div>
                </router-link>
                <router-link custom :to="{name: 'new_deal_performance'}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">New Report</span>
                    </a>
                  </div>
                </router-link>
                <router-link custom :to="{name: 'email_report_settings'}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Email Report Settings</span>
                    </a>
                  </div>
                </router-link>
                <!-- <router-link custom :to="{name: 'my_schedule', params: {module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">My Email Schedules</span>
                    </a>
                  </div>
                </router-link> -->
              </div>
            </div>

            <div v-if="$isProperModule('crm')"
                 data-kt-menu-trigger="click" class="menu-item menu-accordion"
                 :class="{ 'show': hasActiveChildren('/reports/') }">
              <span class="menu-link">
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">Reports</span>
                <span class="menu-arrow"></span>
              </span>
              <div v-if="$hasPermission('Settings', 'create_report')" class="menu-sub menu-sub-accordion menu-active-bg">
                <router-link custom :to="{name: 'crm_report_list'}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Report List</span>
                    </a>
                  </div>
                </router-link>
                <router-link custom :to="{name: 'crm_report_create'}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">New Report</span>
                    </a>
                  </div>
                </router-link>
                <!-- <router-link custom :to="{name: 'my_schedule', params: { module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">My Email Schedules</span>
                    </a>
                  </div>
                </router-link> -->
              </div>
            </div>

            <div
                 data-kt-menu-trigger="click" class="menu-item menu-accordion"
                 :class="{ 'show': hasActiveChildren('/credentials/') || hasActiveChildren('/data_export_schedules/') }">
              <span class="menu-link">
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">Data Export</span>
                <span class="menu-arrow"></span>
              </span>
              <div class="menu-sub menu-sub-accordion menu-active-bg">
                <router-link v-if="$hasPermission('Data', 'add-credentials')" custom :to="{name: 'credentials', params: { module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Credentials</span>
                    </a>
                  </div>
                </router-link>
                <router-link v-if="$hasPermission('Data', 'create-data-export-schedule')" custom :to="{name: 'data_export_schedules', params: { module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Schedules</span>
                    </a>
                  </div>
                </router-link>
              </div>
            </div>
            
            <router-link custom :to="{name: 'bespoke_table'}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Tables</span>
                    </a>
                  </div>
            </router-link>

            <!--            <router-link custom :to="{name: 'group_permission'}" v-slot="{ href, navigate, isActive, isExactActive }">-->
            <!--              <div class="menu-item">-->
            <!--                <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']" @click="navigate">-->
            <!--                  <span class="menu-bullet">-->
            <!--                    <span class="bullet bullet-dot"></span>-->
            <!--                  </span>-->
            <!--                  <span class="menu-title">Group permission</span>-->
            <!--                </a>-->
            <!--              </div>-->
            <!--            </router-link>-->
            <!--<div class="menu-item">
              <a class="menu-link" href="../../demo1/dist/pages/contact.html">
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">Contact Us</span>
              </a>
            </div>-->
          </div>
        </div>


        <div v-if="!$vprops.is_tenant || $isProperModule('project') && hasPresetPermission" 
        data-kt-menu-trigger="click" class="menu-item menu-accordion"
            :class="{ 'show' : hasActiveChildren('/presets') }">
          <span class="menu-link rounded">
            <span class="menu-icon me-0">
              <span class="svg-icon svg-icon-sm">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 18H21M3 18H5M5 18C5 19.3807 6.11929 20.5 7.5 20.5C8.88071 20.5 10 19.3807 10 18C10 16.6193 8.88071 15.5 7.5 15.5C6.11929 15.5 5 16.6193 5 18ZM20 12H21M3 12H10M13 6H21M13 6C13 4.61929 11.8807 3.5 10.5 3.5C9.11929 3.5 8 4.61929 8 6C8 7.38071 9.11929 8.5 10.5 8.5C11.8807 8.5 13 7.38071 13 6ZM3 6H4M16.5 14.5C15.1193 14.5 14 13.3807 14 12C14 10.6193 15.1193 9.5 16.5 9.5C17.8807 9.5 19 10.6193 19 12C19 13.3807 17.8807 14.5 16.5 14.5Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
            </span>
            <span class="menu-title">Presets</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion menu-active-bg">
            <div v-if="0" data-kt-menu-trigger="click" class="menu-item menu-accordion mb-1">
              <span class="menu-link">
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">Company Settings</span>
                <span class="menu-arrow"></span>
              </span>
              <div class="menu-sub menu-sub-accordion">
                <router-link custom :to="{name: 'company_types', params: {module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Company Type</span>
                    </a>
                  </div>
                </router-link>
                <router-link custom :to="{name: 'presets_own', params: {type: 'ownership', module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Ownership</span>
                    </a>
                  </div>
                </router-link>
                <router-link custom :to="{name: 'presets_sc', params: {type: 'corporate_status', module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Corporate Status</span>
                    </a>
                  </div>
                </router-link>

                <router-link custom :to="{name: 'presets_sc', params: {type: 'trading_status', module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Trading Status</span>
                    </a>
                  </div>
                </router-link>
                <router-link custom :to="{name: 'presets_sc', params: {type: 'source_type', module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Source Type</span>
                    </a>
                  </div>
                </router-link>
                <router-link custom :to="{name: 'sectors', params: {module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Sector</span>
                    </a>
                  </div>
                </router-link>
              </div>
            </div>
            <div data-kt-menu-trigger="click" class="menu-item menu-accordion mb-1">
              <span class="menu-link">
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">People</span>
                <span class="menu-arrow"></span>
              </span>
              <div class="menu-sub menu-sub-accordion">
                <router-link custom :to="{name: 'presets_sc', params: {type: 'user_title', module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">User Title</span>
                    </a>
                  </div>
                </router-link>
                <!--<router-link custom :to="{name: 'contact_tags', params: {module: $module}}"-->
                <!--             v-slot="{ href, navigate, isActive, isExactActive }">-->
                <!--  <div class="menu-item">-->
                <!--    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"-->
                <!--       @click="navigate">-->
                <!--      <span class="menu-bullet">-->
                <!--        <span class="bullet bullet-dot"></span>-->
                <!--      </span>-->
                <!--      <span class="menu-title">Person Tags</span>-->
                <!--    </a>-->
                <!--  </div>-->
                <!--</router-link>-->
              </div>
            </div>
            <router-link custom :to="{name: 'transaction_types', params: {module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                <div class="menu-item">
                  <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                      @click="navigate">
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Deal Settings</span>
                  </a>
                </div>
              </router-link>
            <!-- <div data-kt-menu-trigger="click" class="menu-item menu-accordion mb-1">
              <span class="menu-link">
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">Deal Settings</span>
                <span class="menu-arrow"></span>
              </span> -->
              <!-- <div class="menu-sub menu-sub-accordion">
                <router-link custom :to="{name: 'transaction_types', params: {module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Transaction Type</span>
                    </a>
                  </div>
                </router-link>
                <router-link custom :to="{name: 'presets_ps', params: {type: 'project_stage', module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Project Stage</span>
                    </a>
                  </div>
                </router-link>
                <router-link custom :to="{name: 'presets_ps', params: {type: 'buyer_stage', module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Buyer Stages</span>
                    </a>
                  </div>
                </router-link>
                <router-link custom :to="{name: 'project_status', params: {module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Project Status</span>
                    </a>
                  </div>
                </router-link>
              </div> -->
            <!-- </div> -->
            <div data-kt-menu-trigger="click" class="menu-item menu-accordion mb-1">
              <span class="menu-link">
                <span class="menu-bullet">
                  <span class="bullet bullet-dot"></span>
                </span>
                <span class="menu-title">General</span>
                <span class="menu-arrow"></span>
              </span>
              <div class="menu-sub menu-sub-accordion">
                <router-link custom :to="{name: 'currencies', params: {module: $module}}"
                             v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Currencies</span>
                    </a>
                  </div>
                </router-link>
                <router-link custom :to="{name: 'document_types'}" v-slot="{ href, navigate, isActive, isExactActive }">
                  <div class="menu-item">
                    <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                       @click="navigate">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">Document Types</span>
                    </a>
                  </div>
                </router-link>
              </div>
            </div>
            <!-- <template v-for="preset in routes.presets">
              {{preset}}
              <router-link custom :to="{name: preset.route, params: {...preset.params, ...{module: $module}}}"
                           v-slot="{ href, navigate, isActive, isExactActive }">
                <div class="menu-item">
                  <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"
                     @click="navigate">
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">{{ preset.name }}</span>
                  </a>
                </div>
              </router-link>
            </template> -->
            <router-link custom :to="{name: 'crm_custom_settings_form_gui', params: {module: $module}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Form settings v2</span>
                </a>
              </div>
            </router-link>
            <router-link custom :to="{name: 'note_titles', params: {module: $module}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Note Titles</span>
                </a>
              </div>
            </router-link>
          </div>
        </div>

        <!-- crm tenant presets -->
        <div v-if="$isProperModule('crm') && hasPresetPermission" data-kt-menu-trigger="click" class="menu-item menu-accordion"
            :class="{ 'show' : hasActiveChildren('/presets') }">
          <span class="menu-link rounded">
            <span class="menu-icon me-0">
              <span class="svg-icon svg-icon-sm">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 18H21M3 18H5M5 18C5 19.3807 6.11929 20.5 7.5 20.5C8.88071 20.5 10 19.3807 10 18C10 16.6193 8.88071 15.5 7.5 15.5C6.11929 15.5 5 16.6193 5 18ZM20 12H21M3 12H10M13 6H21M13 6C13 4.61929 11.8807 3.5 10.5 3.5C9.11929 3.5 8 4.61929 8 6C8 7.38071 9.11929 8.5 10.5 8.5C11.8807 8.5 13 7.38071 13 6ZM3 6H4M16.5 14.5C15.1193 14.5 14 13.3807 14 12C14 10.6193 15.1193 9.5 16.5 9.5C17.8807 9.5 19 10.6193 19 12C19 13.3807 17.8807 14.5 16.5 14.5Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </span>
            </span>
            <span class="menu-title">Presets</span>
            <span class="menu-arrow"></span>
          </span>
          <div class="menu-sub menu-sub-accordion">
            <!--<router-link custom :to="{name: 'form_categories'}" v-slot="{ href, navigate, isActive, isExactActive }">-->
            <!--    <div class="menu-item">-->
            <!--      <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"-->
            <!--        @click="navigate">-->
            <!--        <span class="menu-bullet">-->
            <!--          <span class="bullet bullet-dot"></span>-->
            <!--        </span>-->
            <!--        <span class="menu-title">Form Section</span>-->
            <!--      </a>-->
            <!--    </div>-->
            <!--  </router-link>-->

            <!--<router-link custom :to="{name: 'pipelines'}" v-slot="{ href, navigate, isActive, isExactActive }">-->
            <!--  <div class="menu-item">-->
            <!--    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"-->
            <!--      @click="navigate">-->
            <!--      <span class="menu-bullet">-->
            <!--        <span class="bullet bullet-dot"></span>-->
            <!--      </span>-->
            <!--      <span class="menu-title">Pipelines</span>-->
            <!--    </a>-->
            <!--  </div>-->
            <!--</router-link>-->

              <!--<router-link custom :to="{name: 'crm_settings'}" v-slot="{ href, navigate, isActive, isExactActive }">-->
              <!--  <div class="menu-item">-->
              <!--    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"-->
              <!--      @click="navigate">-->
              <!--      <span class="menu-bullet">-->
              <!--        <span class="bullet bullet-dot"></span>-->
              <!--      </span>-->
              <!--      <span class="menu-title">Form settings</span>-->
              <!--    </a>-->
              <!--  </div>-->
              <!--</router-link>-->
            <!--<router-link custom :to="{name: 'crm_settings_form_gui'}" v-slot="{ href, navigate, isActive, isExactActive }">-->
            <!--    <div class="menu-item">-->
            <!--      <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"-->
            <!--        @click="navigate">-->
            <!--        <span class="menu-bullet">-->
            <!--          <span class="bullet bullet-dot"></span>-->
            <!--        </span>-->
            <!--        <span class="menu-title">Form settings</span>-->
            <!--      </a>-->
            <!--    </div>-->
            <!--  </router-link>-->

            <router-link custom :to="{name: 'crm_custom_settings_form_gui', params: {module: $module}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Form settings v2</span>
                </a>
              </div>
            </router-link>

            <router-link custom :to="{name: 'note_titles', params: {module: $module}}" v-slot="{ href, navigate, isActive, isExactActive }">
              <div class="menu-item">
                <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                  @click="navigate">
                  <span class="menu-bullet">
                    <span class="bullet bullet-dot"></span>
                  </span>
                  <span class="menu-title">Note Titles</span>
                </a>
              </div>
            </router-link>
            <!--<router-link custom :to="{name: 'contact_tags', params: {module: $module}}"-->
            <!--                 v-slot="{ href, navigate, isActive, isExactActive }">-->
            <!--      <div class="menu-item">-->
            <!--        <a class="menu-link" :href="href" :class="[isActive && 'active', isExactActive && 'active']"-->
            <!--           @click="navigate">-->
            <!--          <span class="menu-bullet">-->
            <!--            <span class="bullet bullet-dot"></span>-->
            <!--          </span>-->
            <!--          <span class="menu-title">Person Tags</span>-->
            <!--        </a>-->
            <!--      </div>-->
            <!--    </router-link>-->

              <!--<router-link custom :to="{name: 'crm_opportunity_status'}" v-slot="{ href, navigate, isActive, isExactActive }">-->
              <!--  <div class="menu-item">-->
              <!--    <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"-->
              <!--      @click="navigate">-->
              <!--      <span class="menu-bullet">-->
              <!--        <span class="bullet bullet-dot"></span>-->
              <!--      </span>-->
              <!--      <span class="menu-title">Opportunity Status</span>-->
              <!--    </a>-->
              <!--  </div>-->
              <!--</router-link>-->

              <router-link custom :to="{name: 'crm_lost_reason'}" v-slot="{ href, navigate, isActive, isExactActive }">
                <div class="menu-item">
                  <a class="menu-link" :class="[isActive && 'active', isExactActive && 'active']" :href="href"
                    @click="navigate">
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">Lost Reasons</span>
                  </a>
                </div>
              </router-link>
          </div>
        </div>

      </div>
      <!--end::Menu-->
    </div>
  <!--end::Aside Menu-->
  </div>
    <!--end::Aside menu-->
  <!--begin::Footer-->
  <div class="aside-footer flex-column-auto" id="kt_aside_footer">
    <!-- <span class="">Footer</span> -->
  </div>
  <!--end::Footer-->
  </div>
</template>

<script>
import ModuleSwitcher from "@cc/ModuleSwitcher.vue";

export default {
  name: "AsideMenu",
  components: {ModuleSwitcher},
  data() {
    return {
      routes: {
        authorization: [
          {route: 'groups', name: 'Groups', hasAccess: () => this.$hasPermission('Settings', 'groups')},
          {route: 'sub_groups', name: 'Subgroups', hasAccess: () => this.$hasPermission('Settings', 'sub-groups')},
          // {route: 'permissions', name: 'Permissions'},
          {
            route: 'group_permission_details',
            name: 'Permission by group',
            hasAccess: () => this.$hasPermission('Settings', 'by-group')
          },
          {
            route: 'user_permission_details',
            name: 'Permission by user',
            hasAccess: () => this.$hasPermission('Settings', 'by-user')
          }
        ],
        presets: [
          {route: 'presets_own', name: 'Ownership', params: {type: 'ownership'}},
          // {route: document-types', name: 'Document Types', params: {type: '''}},
          // {route: 'presets_own', name: 'Departments', params: {type: 'departments'}},
          // {route: currencies', name: 'Currencies', params: {type: '''}},
          // {route: sc/company_type', name: 'Company Type', params: {type: '''}},
          // {route: sc/sector', name: 'Sector', params: {type: '''}},
          {route: 'presets_sc', name: 'Corporate Status', params: {type: 'corporate_status'}},
          {route: 'presets_sc', name: 'Source Type', params: {type: 'source_type'}},
          {route: 'presets_sc', name: 'Trading Status', params: {type: 'trading_status'}},
          {route: 'project_status', name: 'Project Status', params: {}},
          // {route: sc/user_title', name: 'User Title', params: {type: '''}},
          // {route: sc/transaction_type', name: 'Transaction Type', params: {type: '''}},
          // {route: ps/project_stage', name: 'Project Stages', params: {type: '''}},
          {route: 'presets_ps', name: 'Buyer Stages', params: {type: 'buyer_stage'}},
          {route: 'job_title', name: 'Employee Title', params: {type: 'job_title'}},
        ]
      }
    }
  },
  computed: {
    anyAuthPerm() {
      for (let i = 0; i < this.routes.authorization.length; i++) {
        if (this.routes.authorization[i].hasAccess()) {
          return true;
        }
      }
      return false;
    },
    anyUserPerm() {
      return this.$hasPermission('Settings', 'invite-users') || this.$hasPermission('Settings', 'view-users')
    },
    hasPresetPermission() {
      return this.$hasPermission('Settings', 'presets')
    },
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
    openLinkInNewTab(href) {
        window.open(href, '_blank');
    },
  }
}
</script>

<style>
.aside-dark .menu .menu-item .menu-link .menu-icon .svg-icon svg [fill]:not(.permanent):not(g) {
    transition: fill 0.3s ease;
    fill: #D1D5DB !important;
}
</style>